import type { LocalizedDict } from '../index'

export type PaymentGatewaysStrings = {
  breadcrumbAdmin: string
  breadcrumbSettings: string
  title: string
  encryptedNote: string
  simulationNotice: string
  loading: string
  loadError: string
  saveFailed: (status: number) => string
  savedToast: string
  savedToastDescription: string
  saveErrorToast: string
  unknownError: string
  stripeSubtitle: string
  savedCredentialsSource: string
  secretKey: string
  webhookSecret: string
  publishableKey: string
  notSet: string
  configured: string
  stripeCredentials: string
  publishableKeyHint: string
  secretKeyRotate: string
  secretKeyHint: string
  webhookSigningSecret: string
  webhookSigningSecretHint: string
  liveMode: string
  active: string
  whereToFind: string
  cancel: string
  saving: string
  rotateCredentials: string
  saveCredentials: string
  modeLive: string
  modeTest: string
}

export const paymentGatewaysI18n: LocalizedDict<PaymentGatewaysStrings> = {
  en: {
    breadcrumbAdmin: 'Admin',
    breadcrumbSettings: 'Settings',
    title: 'Payment Gateways',
    encryptedNote: 'Integration keys are encrypted at rest (Fernet) and never displayed in full.',
    simulationNotice:
      'Simulation mode — payment gateway credentials require the live backend (real-API build). Saving is disabled here.',
    loading: 'Loading…',
    loadError: 'Could not load gateway configuration.',
    saveFailed: (status) => `save failed (${status})`,
    savedToast: 'Stripe credentials saved',
    savedToastDescription: 'Secret encrypted at rest; only the last 4 digits are shown.',
    saveErrorToast: 'Could not save',
    unknownError: 'Unknown error',
    stripeSubtitle: 'Prepaid wallet cash-in (Model A)',
    savedCredentialsSource: 'saved credentials',
    secretKey: 'Secret key',
    webhookSecret: 'Webhook secret',
    publishableKey: 'Publishable key',
    notSet: 'Not set',
    configured: 'Configured',
    stripeCredentials: 'Stripe credentials',
    publishableKeyHint: 'pk_… — public, safe to share.',
    secretKeyRotate: 'Secret key (re-enter to rotate)',
    secretKeyHint: 'sk_… — encrypted at rest, never displayed again.',
    webhookSigningSecret: 'Webhook signing secret',
    webhookSigningSecretHint: 'whsec_… — verifies incoming Stripe events.',
    liveMode: 'Live mode',
    active: 'Active',
    whereToFind: 'Where do I find these? — Stripe Dashboard → Developers → API keys',
    cancel: 'Cancel',
    saving: 'Saving…',
    rotateCredentials: 'Rotate credentials',
    saveCredentials: 'Save credentials',
    modeLive: 'LIVE',
    modeTest: 'TEST',
  },
  tr: {
    breadcrumbAdmin: 'Yönetim',
    breadcrumbSettings: 'Ayarlar',
    title: 'Ödeme Altyapıları',
    encryptedNote: 'Entegrasyon anahtarları şifreli saklanır (Fernet) ve hiçbir zaman tam gösterilmez.',
    simulationNotice:
      'Simülasyon modu — ödeme altyapısı bilgileri için canlı sunucu gerekir (gerçek API sürümü). Burada kaydetme kapalı.',
    loading: 'Yükleniyor…',
    loadError: 'Ödeme altyapısı ayarları yüklenemedi.',
    saveFailed: (status) => `kaydedilemedi (${status})`,
    savedToast: 'Stripe bilgileri kaydedildi',
    savedToastDescription: 'Gizli anahtar şifreli saklanır; yalnızca son 4 hanesi gösterilir.',
    saveErrorToast: 'Kaydedilemedi',
    unknownError: 'Bilinmeyen hata',
    stripeSubtitle: 'Ön ödemeli cüzdana para yükleme (Model A)',
    savedCredentialsSource: 'kayıtlı bilgiler',
    secretKey: 'Gizli anahtar',
    webhookSecret: 'Webhook gizli anahtarı',
    publishableKey: 'Açık anahtar',
    notSet: 'Girilmemiş',
    configured: 'Ayarlı',
    stripeCredentials: 'Stripe bilgileri',
    publishableKeyHint: 'pk_… — herkese açık, paylaşılabilir.',
    secretKeyRotate: 'Gizli anahtar (değiştirmek için yeniden girin)',
    secretKeyHint: 'sk_… — şifreli saklanır, bir daha gösterilmez.',
    webhookSigningSecret: 'Webhook imza anahtarı',
    webhookSigningSecretHint: 'whsec_… — gelen Stripe olaylarını doğrular.',
    liveMode: 'Canlı mod',
    active: 'Aktif',
    whereToFind: 'Bunları nerede bulurum? — Stripe Dashboard → Developers → API keys',
    cancel: 'Vazgeç',
    saving: 'Kaydediliyor…',
    rotateCredentials: 'Bilgileri değiştir',
    saveCredentials: 'Bilgileri kaydet',
    modeLive: 'CANLI',
    modeTest: 'TEST',
  },
}
